import { EmblaCarouselType } from 'embla-carousel';
import { ComponentPropsWithRef, useCallback, useEffect, useState } from 'react';
import './index.less';

type UseBarButtonType = {
    selectedIndex: number;
    scrollSnaps: number[];
    onBarButtonClick: (index: number) => void;
};

const useBarButton = (
    emblaApi: EmblaCarouselType | undefined,
    onButtonClick?: (emblaApi: EmblaCarouselType) => void
): UseBarButtonType => {
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [scrollSnaps, setScrollSnaps] = useState<number[]>([]);

    const onBarButtonClick = useCallback(
        (index: number) => {
            if (!emblaApi) return;
            emblaApi.scrollTo(index);
            if (onButtonClick) onButtonClick(emblaApi);
        },
        [emblaApi, onButtonClick]
    );

    const onInit = useCallback((emblaApi: EmblaCarouselType) => {
        setScrollSnaps(emblaApi.scrollSnapList());
    }, []);

    const onSelect = useCallback((emblaApi: EmblaCarouselType) => {
        setSelectedIndex(emblaApi.selectedScrollSnap());
    }, []);

    useEffect(() => {
        if (!emblaApi) return;

        onInit(emblaApi);
        onSelect(emblaApi);
        emblaApi.on('reInit', onInit).on('reInit', onSelect).on('select', onSelect);
    }, [emblaApi, onInit, onSelect]);

    return {
        selectedIndex,
        scrollSnaps,
        onBarButtonClick,
    };
};

const EmblaCarouselBarButton = (props: ComponentPropsWithRef<'button'>) => {
    const { children, ...restProps } = props;
    return (
        <button type="button" {...restProps}>
            {children}
        </button>
    );
};

export { EmblaCarouselBarButton, useBarButton };
